import { PrometheusQuerySpec } from '@/core';
import { OffsetHeaderName } from '../get-comparable-data';
import { ResponseHandler, ResultType } from '../types';
import {
  NATIVE_HISTOGRAM_ERROR_MESSAGE,
  TIMESERIES_HISTOGRAM_ERROR_MESSAGE,
  transformTimeSeriesToSingleValueTimeSeries,
} from './utils';

export const singleValueTimeSeriesResponseHandler: ResponseHandler = {
  [ResultType.NativeHistogram]: () => {
    throw new Error(NATIVE_HISTOGRAM_ERROR_MESSAGE);
  },
  [ResultType.TimeSeriesHistogram]: () => {
    throw new Error(TIMESERIES_HISTOGRAM_ERROR_MESSAGE);
  },
  [ResultType.TimeSeries]: async (result, metadata, _notices, context) => {
    // Run range query to get the time series values (following logic from line 425+ in get-data.ts)
    const headers = context.compareDurationInMs
      ? { [OffsetHeaderName]: `${context.compareDurationInMs}ms` }
      : undefined;

    let rangeQueryResponse = context.response;
    // If the results are from an instant query, run a range query to get the time series values
    if (!context.resultsAreFromRangeQuery && context.runRangeQuery) {
      rangeQueryResponse = await context.runRangeQuery(headers);
    }
    const timeSeriesResult = rangeQueryResponse?.data?.result ?? [];

    const data = transformTimeSeriesToSingleValueTimeSeries({
      result,
      spec: context.spec as PrometheusQuerySpec,
      timeSeriesResult,
      compareResult: context.compareResult,
      alias: context.alias,
    });

    return {
      type: 'SingleValueTimeSeries',
      data: {
        values: data,
        metadata,
      },
    };
  },
};
